(function () {
  const HIDDEN_CLASS = 'dr-slider-button--index-hidden';

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function toPositiveNumber(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function initMediaGallery(mediaGallery) {
    if (!mediaGallery || mediaGallery.dataset.drGalleryArrowsReady === 'true') return;

    const viewer = mediaGallery.querySelector('slider-component[id^="GalleryViewer-"]');
    if (!viewer || !viewer.prevButton || !viewer.nextButton) return;

    const prevButton = viewer.prevButton;
    const nextButton = viewer.nextButton;

    function getSlides() {
      return Array.from(viewer.sliderItemsToShow || []).filter((element) => element.clientWidth > 0);
    }

    function getTotalItems() {
      const slides = getSlides();
      return slides.length || viewer.querySelectorAll('[id^="Slide-"]').length || 1;
    }

    function getCurrentItemIndex(totalItems) {
      const slides = getSlides();
      if (!slides.length) return 0;

      const sliderRect = viewer.slider.getBoundingClientRect();
      const sliderCenter = sliderRect.left + sliderRect.width / 2;

      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const slideCenter = rect.left + rect.width / 2;
        const distance = Math.abs(slideCenter - sliderCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return clamp(closestIndex, 0, totalItems - 1);
    }

    function syncArrowVisibility() {
      const totalItems = getTotalItems();
      const currentIndex = getCurrentItemIndex(totalItems);
      const hidePrev = totalItems <= 1 || currentIndex <= 0;
      const hideNext = totalItems <= 1 || currentIndex >= totalItems - 1;

      prevButton.classList.toggle(HIDDEN_CLASS, hidePrev);
      nextButton.classList.toggle(HIDDEN_CLASS, hideNext);
    }

    function queueSync() {
      window.requestAnimationFrame(syncArrowVisibility);
    }

    if (typeof viewer.resetPages === 'function' && !viewer.__drArrowResetPagesPatched) {
      const originalResetPages = viewer.resetPages.bind(viewer);
      viewer.resetPages = function (...args) {
        const result = originalResetPages(...args);
        queueSync();
        return result;
      };
      viewer.__drArrowResetPagesPatched = true;
    }

    viewer.addEventListener('slideChanged', queueSync);
    viewer.slider?.addEventListener('scroll', queueSync, { passive: true });

    const sliderList = viewer.querySelector('[id^="Slider-"]');
    if (sliderList) {
      const observer = new MutationObserver(queueSync);
      observer.observe(sliderList, { childList: true });
    }

    syncArrowVisibility();
    mediaGallery.dataset.drGalleryArrowsReady = 'true';
    queueSync();
  }

  function initAllMediaGalleries() {
    document.querySelectorAll('media-gallery').forEach(initMediaGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllMediaGalleries);
  } else {
    initAllMediaGalleries();
  }
})();
